document.documentElement.classList.remove('no-js');
document.addEventListener('click', async (event) => {
  const toggle = event.target.closest('[data-mobile-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    const open = menu.style.display === 'block';
    menu.style.display = open ? 'none' : 'block';
    toggle.setAttribute('aria-expanded', String(!open));
  }
  const quick = event.target.closest('[data-quick-add]');
  if (quick) {
    event.preventDefault();
    quick.disabled = true;
    const original = quick.textContent;
    quick.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(quick.dataset.variant),quantity:1}]})});
      if(!res.ok) throw new Error('Add failed');
      quick.textContent = 'Added';
      setTimeout(()=>{quick.textContent=original;quick.disabled=false;},1000);
    } catch(e) {
      quick.textContent = 'Choose options';
      window.location.href = quick.dataset.url;
    }
  }
});
